import React, { useEffect } from 'react'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPModal from '../../../../../components/IPModal'
import { useCustomReducer } from '../../../../../base/customHooks'
import Swal from 'sweetalert2'
import IPButton from '../../../../../components/IPButton'
import IPInput from '../../../../../components/IPInput'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { GetPosPriorityApi } from '../service/getPosPriorityApi'
import { ChangeMainPosApi } from '../service/changeMainPosApi'
import { ChangeMainEntegrePosApi } from '../service/changeMainEntegrePosApi'
import { ChangeVodafoneEnablePOSApi } from '../service/changeVodafoneEnablePOSApi'
import { ChangeVodafoneDisablePOSApi } from '../service/changeVodafoneDisablePOSApi'
import { ListPosDataApi } from '../../PosCompany/service/listPosDataApi'
import {
  CardPhoneSettingsApi,
  ICardPhoneSetting,
  CARD_PHONE_SETTING_TITLES,
  CARD_PHONE_BOOLEAN_OPTIONS,
  CARD_PHONE_COMPANY_SETTING,
  CARD_PHONE_DATAGATE_SEGMENT_SETTING,
  CARD_PHONE_DATAGATE_SEGMENT_OPTIONS,
} from '../service/cardPhoneSettingsApi'
import AdminPageAuthGuard from '../../../components/AdminPageAuthGuard'
import { GetCompanyApi } from '../../../components/services/getCompanyApi'
import { IyzicoInstallmentApi, IIyzicoInstallment, toBasketDisplayRate } from '../service/iyzicoInstallmentApi'

import {
  IPosPriority,
  IPosPriorityChangeRequest,
} from '../models/models'
import { IPosData } from '../../PosCompany/models/models'

/**
 * Sepet komisyon satırının EKRAN hâli. Alanlar metin tutulur: kullanıcı "2," yazarken
 * sayıya çevirmek imleci bozar; dönüşüm yalnız kaydederken yapılır.
 */
interface IIyzicoInstallmentRow {
  Id: number
  TaksitSayisi: string
  Oran: string
}

interface IPosPriorityState {
  posPriorityList: IPosPriority[]
  selectedModuleId: number | null
  selectedModuleName: string
  selectedModuleData: string
  priorityValue: string
  nonVodafoneDealerEnabledPosNameList: string[]
  vodafoneDealerEnabledPosNameList: string[]
  isChanging: boolean
  showDetail: boolean
  posList: IPosData[]
  cardPhoneSettings: ICardPhoneSetting[]
  companyOptions: ISelectOption[]
  iyzicoInstallments: IIyzicoInstallmentRow[]
}

interface IModuleConfig {
  moduleName: string
  displayName: string
  turkishTitle: string
  apiClass: any
  methodName: string
  type: 'equalRate' | 'posList' | 'multiSelect'
}

function PosPriority(props: BaseComponentWithContextProps) {
  const getInitialState = (): IPosPriorityState => {
    return {
      posPriorityList: [],
      selectedModuleId: null,
      selectedModuleName: '',
      selectedModuleData: '',
      priorityValue: '',
      nonVodafoneDealerEnabledPosNameList: [],
      vodafoneDealerEnabledPosNameList: [],
      isChanging: false,
      showDetail: false,
      posList: [],
      cardPhoneSettings: [],
      companyOptions: [],
      iyzicoInstallments: [],
    }
  }

  const initialState = getInitialState()
  const [state, setState] = useCustomReducer<IPosPriorityState>(initialState)

  // Modül yapılandırması
  const moduleConfigs: Record<string, IModuleConfig> = {
    equalRateMainPosPriorityType: {
      moduleName: 'equalRateMainPosPriorityType',
      displayName: 'Equal Rate Main POS Priority Type',
      turkishTitle: 'Eşit Oran Ana POS Öncelik Tipi',
      apiClass: ChangeMainPosApi,
      methodName: 'changeMainPos',
      type: 'equalRate',
    },
    equalRatePriorityPosName: {
      moduleName: 'equalRatePriorityPosName',
      displayName: 'Entegre Öncelikli POS',
      turkishTitle: 'Entegre Öncelikli POS Seçimi',
      apiClass: ChangeMainEntegrePosApi,
      methodName: 'changeMainEntegrePos',
      type: 'posList',
    },
    nonVodafoneDealerEnabledPosNameList: {
      moduleName: 'nonVodafoneDealerEnabledPosNameList',
      displayName: 'Non-Vodafone Dealer Enabled POS',
      turkishTitle: 'Vodafone Pasif POS Listesi',
      apiClass: ChangeVodafoneDisablePOSApi,
      methodName: 'changeVodafoneDisablePOS',
      type: 'multiSelect',
    },
    vodafoneDealerEnabledPosNameList: {
      moduleName: 'vodafoneDealerEnabledPosNameList',
      displayName: 'Vodafone Dealer Enabled POS',
      turkishTitle: 'Vodafone Aktif POS Listesi',
      apiClass: ChangeVodafoneEnablePOSApi,
      methodName: 'changeVodafoneEnablePOS',
      type: 'multiSelect',
    },

  }

  useEffect(() => {
    loadPageData()
  }, [])

  const loadPageData = async () => {
    props.showLoading()

    try {
      await Promise.all([
        loadPosPriorities(),
        loadPosList(),
        loadCardPhoneSettings(),
        loadCompanyOptions(),
        loadIyzicoInstallments(),
      ])
    } finally {
      props.hideLoading()
    }
  }

  const loadCardPhoneSettings = async () => {
    try {
      const res = await new CardPhoneSettingsApi({}).getSettings()
      // Datagate segment ayarı hiç kaydedilmemişse sunucu iki segmentte de doğrulama ister;
      // ekran da ikisini seçili gösterir, yoksa ilk "Kaydet" boş değer yazıp doğrulamayı kapatırdı.
      const settings = (res || []).map(item =>
        item.Modul === CARD_PHONE_DATAGATE_SEGMENT_SETTING && item.Data == null
          ? { ...item, Data: CARD_PHONE_DATAGATE_SEGMENT_OPTIONS.map(o => o.value).join(',') }
          : item
      )
      setState({ cardPhoneSettings: settings })
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'SMS doğrulama ayarları alınırken hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
  }

  const loadCompanyOptions = async () => {
    try {
      const res = await new GetCompanyApi({}).getCompanies()
      if (res) {
        // Ödeme akışında kullanılan şirket değeri SAP kodu (Code), Id değil.
        setState({
          companyOptions: res
            .filter(c => c.Code != null)
            .map(c => ({ label: c.Name, value: String(c.Code) })),
        })
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Şirket listesi alınırken hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
  }

  /** Virgüllü şirket kodu metnini seçili option listesine çevirir. */
  const getSelectedCompanyOptions = (data: string | null): ISelectOption[] => {
    const codes = (data || '')
      .split(',')
      .map(x => x.trim())
      .filter(x => x.length > 0)

    return codes.map(
      code => state.companyOptions.find(o => String(o.value) === code) || { label: code, value: code }
    )
  }

  const changeCardPhoneSetting = (modul: string, data: string) => {
    setState({
      cardPhoneSettings: state.cardPhoneSettings.map(item =>
        item.Modul === modul ? { ...item, Data: data } : item
      ),
    })
  }

  const saveAllCardPhoneSettings = async () => {
    props.showLoading()
    try {
      await new CardPhoneSettingsApi({}).saveSettings(state.cardPhoneSettings)
      Swal.fire({ icon: 'success', title: 'Ayarlar kaydedildi.', showConfirmButton: true })
      await loadCardPhoneSettings()
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Ayarlar kaydedilemedi.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      props.hideLoading()
    }
  }

  // ---- Sepet (İyzico) komisyon oranları ----

  const toRow = (item: IIyzicoInstallment): IIyzicoInstallmentRow => ({
    Id: item.Id,
    TaksitSayisi: String(item.TaksitSayisi ?? ''),
    Oran: String(item.Oran ?? ''),
  })

  /** Virgüllü girişi de kabul eder; boş/geçersizse NaN döner ve kaydetme engellenir. */
  const parseRate = (value: string): number => Number((value || '').replace(',', '.').trim())

  const loadIyzicoInstallments = async () => {
    try {
      const res = await new IyzicoInstallmentApi({}).list()
      setState({ iyzicoInstallments: (res || []).map(toRow) })
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Sepet komisyon oranları alınırken hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
  }

  const changeIyzicoInstallment = (index: number, field: 'TaksitSayisi' | 'Oran', value: string) => {
    setState({
      iyzicoInstallments: state.iyzicoInstallments.map((row, i) =>
        i === index ? { ...row, [field]: value } : row
      ),
    })
  }

  const addIyzicoInstallmentRow = () => {
    setState({
      iyzicoInstallments: [...state.iyzicoInstallments, { Id: 0, TaksitSayisi: '', Oran: '' }],
    })
  }

  /** Kaydedilmemiş satır yalnız ekrandan düşer; kayıtlı satır onay sonrası sunucudan silinir. */
  const removeIyzicoInstallmentRow = async (index: number) => {
    const row = state.iyzicoInstallments[index]

    if (!row.Id) {
      setState({ iyzicoInstallments: state.iyzicoInstallments.filter((_, i) => i !== index) })
      return
    }

    const confirm = await Swal.fire({
      icon: 'question',
      title: `${row.TaksitSayisi} taksit oranı silinsin mi?`,
      text: 'Bu taksit seçeneği sepette kullanılamaz hâle gelir.',
      showCancelButton: true,
      confirmButtonText: 'Sil',
      cancelButtonText: 'Vazgeç',
      allowOutsideClick: false,
    })

    if (!confirm.isConfirmed) return

    props.showLoading()
    try {
      await new IyzicoInstallmentApi({}).delete(row.Id)
      await loadIyzicoInstallments()
      Swal.fire({ icon: 'success', title: 'Oran silindi.', showConfirmButton: true })
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Oran silinemedi.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      props.hideLoading()
    }
  }

  const saveIyzicoInstallments = async () => {
    const rows: IIyzicoInstallment[] = []

    for (const row of state.iyzicoInstallments) {
      const installment = Number((row.TaksitSayisi || '').trim())
      const rate = parseRate(row.Oran)

      if (!Number.isInteger(installment) || installment < 1 || installment > 12) {
        Swal.fire({ icon: 'error', title: 'Taksit sayısı 1 ile 12 arasında bir tam sayı olmalıdır.' })
        return
      }

      // 100 ve üzeri oranda brütleştirme formülü tanımsızdır; sunucu da bu değeri reddeder.
      if (!isFinite(rate) || rate < 0 || rate >= 100) {
        Swal.fire({ icon: 'error', title: 'Komisyon oranı 0 ile 100 arasında (100 hariç) olmalıdır.' })
        return
      }

      rows.push({ Id: row.Id, TaksitSayisi: installment, Oran: rate })
    }

    if (rows.length === 0) {
      Swal.fire({ icon: 'info', title: 'Kaydedilecek oran bulunmuyor.' })
      return
    }

    props.showLoading()
    try {
      const res = await new IyzicoInstallmentApi({}).save(rows)
      setState({ iyzicoInstallments: (res || []).map(toRow) })
      Swal.fire({ icon: 'success', title: 'Sepet komisyon oranları kaydedildi.', showConfirmButton: true })
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Sepet komisyon oranları kaydedilemedi.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      props.hideLoading()
    }
  }

  const loadPosPriorities = async (showLoading: boolean = true) => {
    if (showLoading) {
      props.showLoading()
    }

    try {
      const api = new GetPosPriorityApi({})
      const response = await api.getPosPriority()

      setState({
        posPriorityList: response || [],
      })
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'POS Öncelik listesi alınırken hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      if (showLoading) {
        props.hideLoading()
      }
    }
  }

  const loadPosList = async (showLoading: boolean = false) => {
    if (showLoading) {
      props.showLoading()
    }

    try {
      const api = new ListPosDataApi({})
      const response = await api.listPosData()

      setState({
        posList: response || [],
      })
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'POS listesi alınırken hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      if (showLoading) {
        props.hideLoading()
      }
    }
  }

  const getModuleDisplayName = (moduleName: string): string => {
    const config = moduleConfigs[moduleName]
    return config?.displayName || moduleName
  }

  const getTurkishTitle = (moduleName: string): string => {
    const config = moduleConfigs[moduleName]
    return config?.turkishTitle || moduleName
  }

  const getModuleType = (moduleName: string): 'equalRate' | 'posList' | 'multiSelect' => {
    const config = moduleConfigs[moduleName]
    return config?.type || 'posList'
  }

  const clearSelection = () => {
    setState({
      selectedModuleId: null,
      selectedModuleName: '',
      selectedModuleData: '',
      priorityValue: '',
    })
  }

  const changePriority = async () => {
    if (!state.selectedModuleName || state.selectedModuleName.trim() === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Lütfen bir modül seçiniz.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }

    const moduleType = getModuleType(state.selectedModuleName)

    // For multiSelect, check if array has items; for others, check priorityValue
    const hasSelection = moduleType === 'multiSelect'
      ? (state.nonVodafoneDealerEnabledPosNameList.length > 0 || state.vodafoneDealerEnabledPosNameList.length > 0)
      : (state.priorityValue && state.priorityValue.trim() !== '')

    if (!hasSelection) {
      Swal.fire({
        icon: 'warning',
        title: moduleType === 'multiSelect'
          ? 'Lütfen en az bir POS seçiniz.'
          : 'Lütfen öncelik değerini giriniz.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }

    const moduleConfig = moduleConfigs[state.selectedModuleName]
    if (!moduleConfig) {
      Swal.fire({
        icon: 'error',
        title: 'Geçersiz modül seçildi.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }

    // Determine the text value to send
    let textValue = ''
    if (moduleType === 'multiSelect') {
      if (state.selectedModuleName === 'nonVodafoneDealerEnabledPosNameList') {
        textValue = state.nonVodafoneDealerEnabledPosNameList.join(',')
      } else if (state.selectedModuleName === 'vodafoneDealerEnabledPosNameList') {
        textValue = state.vodafoneDealerEnabledPosNameList.join(',')
      }
    } else {
      textValue = state.priorityValue
    }

    const request: IPosPriorityChangeRequest = {
      Text: textValue,
    }

    setState({ isChanging: true })
    props.showLoading()
    try {
      const apiInstance = new moduleConfig.apiClass({})
      const response = await apiInstance[moduleConfig.methodName](request)

      if (response) {
        Swal.fire({
          icon: 'success',
          title: `${getModuleDisplayName(state.selectedModuleName)} için işlem başarıyla tamamlanmıştır.`,
          showConfirmButton: true,
          allowOutsideClick: false,
        })

        clearSelection()
        await loadPosPriorities(false)
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'İşlem gerçekleştirilirken hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      setState({ isChanging: false })
      props.hideLoading()
    }
  }

  // Seçenekleri alma fonksiyonları
  const getEqualRateOptions = (): ISelectOption[] => {
    return [
      { label: 'Normal', value: 'Normal' },
      { label: 'Diğer', value: 'Diğer' },
    ]
  }

  const getPosListOptions = (): ISelectOption[] => {
    return state.posList.map(pos => ({
      label: pos.Name,
      value: pos.Name,
    }))
  }

  const getSelectedOption = (): ISelectOption | null => {
    const moduleType = getModuleType(state.selectedModuleName)

    if (moduleType === 'equalRate') {
      const options = getEqualRateOptions()
      return options.find(opt => opt.value === state.priorityValue) || null
    } else {
      const options = getPosListOptions()
      return options.find(opt => opt.value === state.priorityValue) || null
    }
  }

  const getSelectedMultiOptions = (): ISelectOption[] => {
    const options = getPosListOptions()
    let selectedIds: string[] = []

    if (state.selectedModuleName === 'nonVodafoneDealerEnabledPosNameList') {
      selectedIds = state.nonVodafoneDealerEnabledPosNameList
    } else if (state.selectedModuleName === 'vodafoneDealerEnabledPosNameList') {
      selectedIds = state.vodafoneDealerEnabledPosNameList
    }

    return options.filter(opt => selectedIds.includes(opt.value.toString()))
  }

  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header'>
            <span className='h4'>POS Öncelik Değiştirme</span>
          </div>

          <div className='card-body'>
            {state.posPriorityList && state.posPriorityList.length > 0 ? (
              <div>
                {state.posPriorityList.map((module, index) => (
                  <div key={module.Id} className='mb-4'>
                    {/* Servis Başlığı */}
                    <div className='mb-3'>
                      <h5 className='mb-2 text-primary'>
                        <strong>{getTurkishTitle(module.Modul)}</strong>
                      </h5>
                    </div>

                    {/* Servis Paneli */}
                    <div className='row'>
                      {/* Bilgi Bölümü */}
                      <div className='col-lg-4 mb-3'>
                        <div className='card h-100' style={{ borderLeft: '4px solid #007bff' }}>
                          <div className='card-body'>
                            <small className='text-muted d-block mb-2'>
                              <strong>Modül:</strong> {module.Modul}
                            </small>
                            <small className='text-muted d-block'>
                              <strong>Veri:</strong> {module.Data || 'N/A'}
                            </small>
                          </div>
                        </div>
                      </div>

                      {/* Seçim Bölümü */}
                      <div className='col-lg-8 mb-3'>
                        <div className='card h-100'>
                          <div className='card-body'>
                            <div className='row align-items-end'>
                              <div className='col-lg-8'>
                                <label className='form-label'>
                                  <strong>
                                    {getModuleType(module.Modul) === 'multiSelect'
                                      ? 'POS Seçiniz (Çoklu)'
                                      : 'Değer Seçiniz'}
                                  </strong>
                                </label>
                                {getModuleType(module.Modul) === 'multiSelect' ? (
                                  <IPSelectBox
                                    name={`priority-${module.Id}`}
                                    placeholder='Seçiniz'
                                    isClearable
                                    isMulti
                                    options={getPosListOptions()}
                                    value={
                                      state.selectedModuleId === module.Id
                                        ? getSelectedMultiOptions()
                                        : []
                                    }
                                    onChangeMulti={(options: ISelectOption[]) =>
                                      setState({
                                        selectedModuleId: module.Id,
                                        selectedModuleName: module.Modul,
                                        selectedModuleData: module.Data,
                                        [module.Modul]: options.map(opt => opt.value.toString()),
                                      } as any)
                                    }
                                  />
                                ) : (
                                  <IPSelectBox
                                    name={`priority-${module.Id}`}
                                    placeholder='Seçiniz'
                                    isClearable
                                    options={
                                      getModuleType(module.Modul) === 'equalRate'
                                        ? getEqualRateOptions()
                                        : getPosListOptions()
                                    }
                                    value={
                                      state.selectedModuleId === module.Id
                                        ? getSelectedOption()
                                        : null
                                    }
                                    onChangeSingle={option =>
                                      setState({
                                        selectedModuleId: module.Id,
                                        selectedModuleName: module.Modul,
                                        selectedModuleData: module.Data,
                                        priorityValue: option?.value?.toString() || '',
                                      })
                                    }
                                  />
                                )}
                              </div>

                              <div className='col-lg-4'>
                                <IPButton
                                  text='Değiştir'
                                  type='button'
                                  onClick={() => {
                                    setState({
                                      selectedModuleId: module.Id,
                                      selectedModuleName: module.Modul,
                                      selectedModuleData: module.Data,
                                    })
                                    changePriority()
                                  }}
                                  disabled={
                                    state.isChanging ||
                                    state.selectedModuleId !== module.Id ||
                                    (getModuleType(module.Modul) === 'multiSelect'
                                      ? (module.Modul === 'nonVodafoneDealerEnabledPosNameList'
                                        ? state.nonVodafoneDealerEnabledPosNameList.length === 0
                                        : state.vodafoneDealerEnabledPosNameList.length === 0)
                                      : !state.priorityValue)
                                  }
                                  className='btn btn-success'
                                  style={{
                                    width: '100%',
                                    height: '36px',
                                    color: 'white',
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Ayırıcı */}
                    {index < state.posPriorityList.length - 1 && (
                      <hr className='my-4' />
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className='alert alert-info'>
                Hiçbir POS Öncelik servisi bulunamadı.
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ---- Kart-Telefon SMS Doğrulaması ---- */}
      <div className='card mt-4'>
        <div className='card-header'>
          <h6 className='mb-0'>Kart - Telefon SMS Doğrulaması</h6>
        </div>
        <div className='card-body'>
          <div className='alert alert-info'>
            <strong>Muaf bayiler:</strong> SMS doğrulamasından muaf tutulacak bayiler SAP'ta{' '}
            <strong>DEALERNONSMS</strong> alt tipine eklenmelidir. Bu liste B2B üzerinden düzenlenemez —
            bayi alt tipleri SAP senkronuyla yeniden yazılır.
          </div>

          <div className='alert alert-secondary'>
            <strong>Metinler:</strong> Kısa yazı, kart hamili beyan metni, KVKK aydınlatma metni ve
            SMS metinleri hukuki beyan içerdiği için buradan düzenlenmez; sunucudaki şablon
            dosyalarında tutulur: <code>card-phone-kisa-yazi.html</code>,{' '}
            <code>card-phone-uzun-yazi.html</code>, <code>card-phone-kvkk.html</code>,{' '}
            <code>card-phone-sms-link.txt</code>, <code>card-phone-sms-kod.txt</code>.
          </div>

          {state.cardPhoneSettings.map(setting => (
            <div className='row align-items-center mb-3' key={setting.Modul}>
              <div className='col-md-4'>
                <label className='text-sm-left'>{CARD_PHONE_SETTING_TITLES[setting.Modul] || setting.Modul}</label>
              </div>
              <div className='col-md-8'>
                {setting.Modul === CARD_PHONE_COMPANY_SETTING ? (
                  <IPSelectBox
                    name={setting.Modul}
                    placeholder='Şirket seçiniz'
                    isClearable
                    isMulti
                    options={state.companyOptions}
                    value={getSelectedCompanyOptions(setting.Data)}
                    onChangeMulti={(options: ISelectOption[]) =>
                      changeCardPhoneSetting(
                        setting.Modul,
                        (options || []).map(o => o.value).join(',')
                      )
                    }
                  />
                ) : setting.Modul === CARD_PHONE_DATAGATE_SEGMENT_SETTING ? (
                  <IPSelectBox
                    name={setting.Modul}
                    placeholder='Segment seçiniz (boş ise hiçbir Datagate bayisinde çalışmaz)'
                    isClearable
                    isMulti
                    options={CARD_PHONE_DATAGATE_SEGMENT_OPTIONS}
                    value={CARD_PHONE_DATAGATE_SEGMENT_OPTIONS.filter(o =>
                      (setting.Data || '')
                        .split(',')
                        .map(x => x.trim())
                        .includes(o.value)
                    )}
                    onChangeMulti={(options: ISelectOption[]) =>
                      changeCardPhoneSetting(
                        setting.Modul,
                        (options || []).map(o => o.value).join(',')
                      )
                    }
                  />
                ) : CARD_PHONE_BOOLEAN_OPTIONS[setting.Modul] ? (
                  <IPSelectBox
                    name={setting.Modul}
                    placeholder='Seçiniz'
                    options={CARD_PHONE_BOOLEAN_OPTIONS[setting.Modul]}
                    value={
                      CARD_PHONE_BOOLEAN_OPTIONS[setting.Modul].find(
                        o => o.value === (setting.Data || '').trim().toLowerCase()
                      ) || null
                    }
                    onChangeSingle={option => changeCardPhoneSetting(setting.Modul, option?.value?.toString() || '')}
                  />
                ) : (
                  <IPInput
                    type='text'
                    className='form-control'
                    name={setting.Modul}
                    value={setting.Data || ''}
                    onChange={e => changeCardPhoneSetting(setting.Modul, e.target.value)}
                  />
                )}
              </div>
            </div>
          ))}

          <div className='row'>
            <div className='col-md-12 text-end'>
              <IPButton text='Kaydet' type='button' onClick={saveAllCardPhoneSettings} />
            </div>
          </div>
        </div>
      </div>

      {/* ---- Sepet (İyzico) Komisyon Oranları ---- */}
      <div className='card mt-4'>
        <div className='card-header'>
          <h6 className='mb-0'>Sepet (İyzico ile Öde) Komisyon Oranları</h6>
        </div>
        <div className='card-body'>
          <div className='alert alert-info'>
            Buradaki oranlar sitenin <strong>genel</strong> sepet oranlarıdır. Ürün bazlı İyzico
            kampanyası tanımlıysa o üründe kampanya oranı geçerli olur — kampanyalar{' '}
            <strong>Ürün İşlemleri &gt; İyzico Kampanya</strong> ekranından yönetilir.
          </div>

          <div className='alert alert-secondary'>
            <strong>Komisyon Oranı</strong> girilen ham değerdir. Bayinin sepette ve chatbotta
            gördüğü vade farkı bundan hesaplanır: <code>oran / (1 - oran / 100)</code>. Sağdaki
            kolon bu hesabı canlı gösterir.
          </div>

          <table className='table table-bordered'>
            <thead className='table-light'>
              <tr>
                <th style={{ width: '25%' }}>Taksit Sayısı</th>
                <th style={{ width: '30%' }}>Komisyon Oranı (%)</th>
                <th style={{ width: '30%' }}>Sepette Görünen Oran (%)</th>
                <th style={{ width: '15%' }}></th>
              </tr>
            </thead>
            <tbody>
              {state.iyzicoInstallments.length === 0 && (
                <tr>
                  <td colSpan={4} className='text-center'>
                    Tanımlı sepet komisyon oranı yok.
                  </td>
                </tr>
              )}
              {state.iyzicoInstallments.map((row, index) => {
                const displayRate = toBasketDisplayRate(parseRate(row.Oran))
                return (
                  <tr key={row.Id || `new-${index}`}>
                    <td>
                      <IPInput
                        type='number'
                        className='form-control'
                        name={`iyzico-installment-${index}`}
                        value={row.TaksitSayisi}
                        onChange={e => changeIyzicoInstallment(index, 'TaksitSayisi', e.target.value)}
                      />
                    </td>
                    <td>
                      <IPInput
                        type='text'
                        className='form-control'
                        name={`iyzico-rate-${index}`}
                        value={row.Oran}
                        onChange={e => changeIyzicoInstallment(index, 'Oran', e.target.value)}
                      />
                    </td>
                    <td className='align-middle'>{displayRate === null ? '-' : `%${displayRate}`}</td>
                    <td className='text-center'>
                      <IPButton
                        text='Sil'
                        type='button'
                        className='btn btn-danger'
                        style={{ width: '100%', height: '36px', color: 'white' }}
                        onClick={() => removeIyzicoInstallmentRow(index)}
                      />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <div className='row'>
            <div className='col-md-6'>
              <IPButton text='Satır Ekle' type='button' onClick={addIyzicoInstallmentRow} />
            </div>
            <div className='col-md-6 text-end'>
              <IPButton text='Kaydet' type='button' onClick={saveIyzicoInstallments} />
            </div>
          </div>
        </div>
      </div>

      <IPModal
        show={state.showDetail}
        onClose={() =>
          setState({
            showDetail: false,
          })
        }
        title='İşlem Detayı'
        width={900}
        hideConfirm={true}
      >
        <div>İşlem detayı</div>
      </IPModal>
    </div>
  )
}

function GuardedPosPriority(props: BaseComponentWithContextProps) {
  return (
    <AdminPageAuthGuard route='PosSettingsAuth' title='POS Ayarları'>
      <PosPriority {...props} />
    </AdminPageAuthGuard>
  )
}

export default componentWithContext(GuardedPosPriority)

